module.exports = __webpack_public_path__ + "static/6312-f0bb3f9970ed6f09baf4b86deef1f5be.png";